import { render, staticRenderFns } from "./CompanyConfigDialog.vue?vue&type=template&id=165d717c&scoped=true&"
import script from "./CompanyConfigDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConfigDialog.vue?vue&type=style&index=0&id=165d717c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d717c",
  null
  
)

export default component.exports